import {createContext} from "react";
import { defaultUser} from "../utils/constant";
import {User} from "../Models/User";
import {ParticipantData} from "../interface/Participant.interface";

export const AdminUserContext = createContext<{
    users: User[],
    updateUsers: Function,
    selectedProjectParticipant?: ParticipantData,
    updateSelectedProjectParticipant: Function,

}>({
    users: [new User(defaultUser)],
    updateUsers: (u: User) => {},
    selectedProjectParticipant: undefined,
    updateSelectedProjectParticipant: (u: ParticipantData) => {
    }
})